module.exports = __webpack_public_path__ + "img/table.06e5f5cc.svg";